export const extractWebsite = (url) => {
  const matches = url.match(/https?:\/\/(?:www\.)?([^\\/]+)/);

  if (matches) {
    return matches[1];
  }

  return url;
};
